<template>
  <div>
    <div class="sig-box"><canvas ref="canvas"></canvas></div>
    <div class="text-right"><button type="button" class="btn btn-link btn-sm p-0" @click="clear">Clear signature</button></div>
  </div>
</template>

<script>
// Finger / stylus / mouse signature. Emits a PNG data URL (or null when cleared).
export default {
  name: 'SignaturePad',
  data() { return { drawing: false, last: null, ctx: null }; },
  mounted() {
    const c = this.$refs.canvas;
    this.ctx = c.getContext('2d');
    c.addEventListener('pointerdown', this.down);
    c.addEventListener('pointermove', this.move);
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(ev => c.addEventListener(ev, this.up));
    // Modals render hidden first; size once visible.
    this.$nextTick(() => setTimeout(this.fit, 150));
    window.addEventListener('resize', this.fit);
  },
  beforeDestroy() { window.removeEventListener('resize', this.fit); },
  methods: {
    fit() {
      const c = this.$refs.canvas;
      if (!c) return;
      const ratio = window.devicePixelRatio || 1;
      const r = c.getBoundingClientRect();
      c.width = r.width * ratio; c.height = r.height * ratio;
      this.ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      Object.assign(this.ctx, { lineWidth: 2.2, lineCap: 'round', lineJoin: 'round', strokeStyle: '#111' });
      this.$emit('input', null);
    },
    pos(e) { const r = this.$refs.canvas.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; },
    down(e) { this.drawing = true; this.last = this.pos(e); this.$refs.canvas.setPointerCapture(e.pointerId); },
    move(e) {
      if (!this.drawing) return;
      const p = this.pos(e);
      this.ctx.beginPath(); this.ctx.moveTo(this.last.x, this.last.y); this.ctx.lineTo(p.x, p.y); this.ctx.stroke();
      this.last = p;
    },
    up() {
      if (!this.drawing) return;
      this.drawing = false;
      this.$emit('input', this.$refs.canvas.toDataURL('image/png'));
    },
    clear() {
      const c = this.$refs.canvas;
      this.ctx.clearRect(0, 0, c.width, c.height);
      this.$emit('input', null);
    },
  },
};
</script>

<style scoped>
.sig-box { border: 2px dashed #ced4da; border-radius: 8px; background: #fff; touch-action: none; }
.sig-box canvas { width: 100%; height: 170px; display: block; }
</style>
